import 'Styles/templates/page.second-turn.scss';
import Tabs from '../components/tabs';
import productSliderApp from '../vue/product-slider/index';
import showMoreLess from '../components/show-more-less';
import Tooltip from '../components/tooltip';

Tabs();
productSliderApp();
showMoreLess();
Tooltip();

const drawerTriggers = document.querySelectorAll('[data-trade-in-drawer]');
const faqSection = document.querySelector('.ga');

faqSection && faqSection.setAttribute('id', 'trade-in-faq');

if (drawerTriggers) {
  drawerTriggers.forEach((el) => {
    if (el.innerHTML == 'Trade-in your gear') {
      const wrapperDiv = document.createElement('div');
      const dividerText = document.createElement('span');
      dividerText.innerHTML = 'or';
      dividerText.classList.add('st__btn-seperator');
      wrapperDiv.appendChild(dividerText);
      el.parentNode.replaceChild(wrapperDiv, el);
      wrapperDiv.appendChild(el);
    }
    el.addEventListener('click', () => {
      window.toggleDrawer(true, 'TradeIn');
    });
  });
}
